import React from "react";
import {IconButton} from "@mui/material";

export default function DHButtonIcon({ icon, disabled, onClick, style}) {

    return <IconButton color="primary" disabled={disabled} size="large" onClick={onClick} style={{padding:5, ... style}}>
        {icon}
    </IconButton>
}